import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, NotebookPen, CircleDollarSign, LogOut, KeyRound } from 'lucide-react';
import axios from 'axios';
import { useState, useEffect, useRef } from 'react';
import { MessageModal } from '../../component/modal/modal';
import '../styles/v2.css';

function HeaderV2() {
    const location = useLocation();
    const navigate = useNavigate();
    const MyData = useSelector((state) => state.MyData);
    const hostLogoImg = useSelector((state) => state.hostLogoImg.value);
    const Current_Location = useSelector((state) => state.Current_Location.value);
    
    const [message, setMessage] = useState("");
    const [passwordModal, setPasswordModal] = useState(false);
    const [logoutBtn, setLogoutBtn] = useState(false);
    const logoutRef = useRef(null);

    // 외부 클릭 시 드롭다운 닫기
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (logoutRef.current && !logoutRef.current.contains(event.target)) {
                setLogoutBtn(false);
            }
        };

        if (logoutBtn) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [logoutBtn]);

    const onSubmit = async () => {
        if (window.confirm("로그아웃을 하시겠습니까?")) {
            await axios.post(process.env.REACT_APP_API + "/api/user/logout", {}, {
                withCredentials: true,
            }).then((response) => {
                let tmp = response?.data;
                if (tmp?.code < 2000) {
                    setLogoutBtn(false);
                    navigate('/');
                } else {
                    setMessage({ msg: "로그아웃에 실패했습니다." });
                }
            }).catch(error => {
                console.error(error);
            });
        }
    };

    const menuItems = [
        {
            path: '/v2/dashboard',
            label: '대시보드',
            icon: LayoutDashboard,
            show: true
        },
        {
            path: '/v2/paylist',
            label: '거래조회',
            icon: NotebookPen,
            show: true
        },
        {
            path: '/v2/settlement',
            label: '정산내역',
            icon: CircleDollarSign,
            show: true
        }
    ];

    return (
        <>
            <MessageModal message={message} />
            <header 
                style={{
                    height: '60px',
                    background: '#f5f5f5',
                    borderBottom: '1px solid #d1d5db',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0 16px',
                    position: 'sticky',
                    top: 0,
                    zIndex: 1000
                }}
            >
                {/* 로고 영역 */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                    <Link to="/v2/dashboard" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                        {hostLogoImg === "onu" ? (
                            <img src="/img/ong.jpg" alt="Logo" style={{ height: '32px' }} />
                        ) : (
                            <img src="/img/dl_logo_white.png" alt="Logo" style={{ height: '32px' }} />
                        )}
                    </Link>
                    
                    {/* 메뉴 영역 */}
                    <nav style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        {menuItems.map((item, idx) => {
                            if (!item.show) return null;
                            const Icon = item.icon;
                            const isActive = location.pathname === item.path || 
                                           (item.path === '/v2/paylist' && location.pathname.startsWith('/v2/paylist'));
                            
                            return (
                                <Link
                                    key={idx}
                                    to={item.path}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        padding: '8px 16px',
                                        fontSize: '14px',
                                        color: isActive ? '#3b82f6' : '#333',
                                        background: isActive ? 'white' : 'transparent',
                                        border: isActive ? '1px solid #d1d5db' : '1px solid transparent',
                                        borderBottom: isActive ? 'none' : '1px solid transparent',
                                        textDecoration: 'none',
                                        fontWeight: isActive ? '500' : '400',
                                        cursor: 'pointer',
                                        position: 'relative',
                                        zIndex: isActive ? 1 : 0
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isActive) {
                                            e.target.style.background = '#f0f0f0';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isActive) {
                                            e.target.style.background = 'transparent';
                                        }
                                    }}
                                >
                                    <Icon size={16} />
                                    <span>{item.label}</span>
                                </Link>
                            );
                        })}
                    </nav>
                </div>

                {/* 사용자 정보 영역 */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <span style={{ fontSize: '14px', color: '#666' }}>
                        {MyData?.co_nm || '사용자'}
                    </span>
                    <div style={{ position: 'relative' }} ref={logoutRef}>
                        <button
                            onClick={() => setLogoutBtn(!logoutBtn)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '6px 12px',
                                fontSize: '13px',
                                background: 'white',
                                border: '1px solid #d1d5db',
                                cursor: 'pointer',
                                color: '#333'
                            }}
                            onMouseEnter={(e) => e.target.style.background = '#f0f0f0'}
                            onMouseLeave={(e) => e.target.style.background = 'white'}
                        >
                            <KeyRound size={14} />
                            <span>설정</span>
                        </button>
                        
                        {logoutBtn && (
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '100%',
                                    right: 0,
                                    marginTop: '4px',
                                    background: 'white',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '4px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                    zIndex: 1000,
                                    minWidth: '120px'
                                }}
                            >
                                <button
                                    onClick={onSubmit}
                                    style={{
                                        width: '100%',
                                        padding: '8px 12px',
                                        fontSize: '13px',
                                        background: 'white',
                                        border: 'none',
                                        cursor: 'pointer',
                                        color: '#333',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        textAlign: 'left'
                                    }}
                                    onMouseEnter={(e) => e.target.style.background = '#f0f0f0'}
                                    onMouseLeave={(e) => e.target.style.background = 'white'}
                                >
                                    <LogOut size={14} />
                                    <span>로그아웃</span>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </header>
        </>
    );
}

export default HeaderV2;
